import '../GerenciamentoTurmas/GerenciamentoTurmas.css';
import '../../Login.css'
import React, { useState, useEffect } from 'react';
import { FormGroup, Table, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { Turnstile } from '@marsidev/react-turnstile'
import { JournalBookmark, DashCircleFill } from 'react-bootstrap-icons';
import { QRCodeCanvas } from 'qrcode.react';
import SescLogo from '../../Assets/Sesc-SC-Logo.png';
import axios from 'axios';

const GeradorQrExterno = () => {
    const username = process.env.REACT_APP_ANJO_BACKEND_USER
    const password = process.env.REACT_APP_ANJO_BACKEND_PSW

    const [cpfUsuario, setCpfUsuario] = useState();
    const [codigoQrCpf, setCodigoQrCpf] = useState(null);
    const [turnstileToken, setTurnstileToken] = useState(null);

    const sendCpf = async (cpf) => {
        console.log(cpf)
        if (turnstileToken === null) {
            alert('Captcha não reconhecido, por favor preeencher.');
        } else {
            const response = await axios.post("responsavel/gerarCpfQrCode/" + cpf,
                {
                    turnstileToken
                }, {
                auth: {
                    username,
                    password
                }
            })
            if (response.data) {
                setCodigoQrCpf(response.data);
            } else {
                alert('Captcha não reconhecido, ou cpf não cadastrado.');
                setTimeout(() => {
                    window.location.reload();
                }, 2000)
            }
           
        }
    }

    const formatCPF = (inputCPF) => {
        inputCPF = inputCPF.replace(/\D/g, '');

        if (inputCPF.length > 11) {
            inputCPF = inputCPF.slice(0, 11);
        }

        const formattedCPF = inputCPF.padStart(11, '0');
        setCpfUsuario(formattedCPF);
    }

    const handleVerificationSuccess = async (token) => {
        setTurnstileToken(token);
    }

    return (
        <div className="Home">
            <img src={SescLogo} className="LogoGerador" />
            <div className="Titulo">
                <strong>ANJO SESC</strong>
            </div>
            <div className="LoginForm">
                <div className="SubTitulo">
                    Gerador de Códigos QR
                </div>
                {codigoQrCpf === null ? (
                    <>
                        <input type="text" placeholder="CPF" className="CpfInput" maxlength="14"
                            onChange={(e) => formatCPF(e.target.value)} />
                        <Turnstile
                            siteKey={process.env.REACT_APP_TURNSTILE_KEY}
                            onSuccess={(token) => handleVerificationSuccess(token)}
                        />
                        <Button className="submitRegistrosButton" onClick={() => sendCpf(cpfUsuario)}>
                            ENVIAR
                        </Button>
                    </>) :
                    (
                        <div className="BackgroundQrCode">
                            <QRCodeCanvas value={codigoQrCpf.toString()} />
                        </div>
                    )}
            </div>
        </div>
    );
   
}

export default GeradorQrExterno;